import { Phone } from "lucide-react";

export function TopBar() {
  return (
    <div className="bg-brand text-white text-xs sm:text-sm">
      <div className="container mx-auto px-4 py-2 flex flex-col sm:flex-row items-center justify-between gap-1 sm:gap-4 font-body">
        <span className="hidden sm:inline">7am - 5pm Mon - Fri</span>
        <span className="hidden md:inline">Business License Number 0450850225</span>
        <a
          href="tel:5015936361"
          className="inline-flex items-center gap-2 hover:underline font-semibold"
        >
          <Phone className="h-3.5 w-3.5" />
          501-593-6361
        </a>
      </div>
    </div>
  );
}
